<script lang="ts">
  import { Col, Container, Form, Input, Label, Row } from "sveltestrap";
  import BookmarkCheckout from "./BookmarkCheckout.svelte";
  import Card from "../../../Core/Card.svelte";
  import { BillingDetails } from "../../../../utils/Constant/Constant";
  import ProductTotal from "./ProductTotal.svelte";
  import data from "../../../../Data/Ecommerce/Ecommerce.json"
  import CheckoutForm from "./CheckoutForm.svelte";

</script>
<BookmarkCheckout />
<Container fluid >
    <Card headerTitle={BillingDetails} cardHeaderprops="pb-0" cardProps="checkout">
      <div slot="contentbody">
        <Row>
          <Col xl="6" sm="12">
            <Form>
                {#each data.billingdata as billingItem}
                    <Row>
                        {#each billingItem.formdata as formItem}
                            <Col sm="6" class="mb-3">
                                <Label for={formItem.id}>{formItem.label}</Label>
                                <Input id={formItem.id} required type={formItem.types} />
                            </Col>
                        {/each}
                    </Row>
                {/each}
                <CheckoutForm />
            </Form>
          </Col>
          <ProductTotal />
        </Row>
      </div>
    </Card>
</Container>